import { z } from 'zod';

export const googleProviderOptions = z.object({
  candidateCount: z.number().int().min(1).max(8).optional(),
  responseModalities: z.array(z.enum(['TEXT', 'IMAGE', 'AUDIO'])).optional(),
  mediaResolution: z.string().optional(),
  cachedContent: z.string().optional(),
  enableEnhancedCivicAnswers: z.boolean().optional(),
  labels: z.record(z.string(), z.string()).optional(),
  safetySettings: z.array(z.record(z.string(), z.unknown())).optional(),
  thinkingConfig: z.record(z.string(), z.unknown()).optional(),
  imageConfig: z.record(z.string(), z.unknown()).optional(),

  numberOfImages: z.number().int().min(1).max(4).optional(),
  negativePrompt: z.string().optional(),
  aspectRatio: z.string().optional(),
  guidanceScale: z.number().optional(),
  safetyFilterLevel: z.string().optional(),
  personGeneration: z.string().optional(),
  includeSafetyAttributes: z.boolean().optional(),
  includeRaiReason: z.boolean().optional(),
  language: z.string().optional(),
  outputMimeType: z.string().optional(),
  outputCompressionQuality: z.number().int().optional(),
  addWatermark: z.boolean().optional(),
  imageSize: z.string().optional(),
  enhancePrompt: z.boolean().optional(),
  editMode: z.string().optional(),
  baseSteps: z.number().int().optional(),
}).passthrough();

export type GoogleProviderOptions = z.infer<typeof googleProviderOptions>;
